import React from 'react';
import { Text, Button } from 'reaxl';
import { Form, Input, Select } from 'reaxl-forms';
import { useDispatch } from 'react-redux';
import { addValidationRule } from 'formsy-react';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import useBrowseByBudget from '@/hooks/useBrowseByBudget';
import { convertPrice } from '@/utilities';
import { paymentsDuck } from '@/ducks';

const priceMask = createNumberMask();

function BrowseByBudgetForm({ withPixallData }) {
    const dispatch = useDispatch();

    const additionalParams = {
        isBudgetTab: false,
    };

    const {
        populatePriceInputValue,
        handleInputBlur,
        handleSubmit,
        setBudgetSummaryType,
        budgetSummaryType,
    } = useBrowseByBudget(additionalParams, withPixallData);

    addValidationRule('isValidPrice', (values, value) => {
        const price = convertPrice(value);
        if (price) {
            return price >= 0;
        }
        return true;
    });

    return (
        <Form
            id="browseByBudgetForm"
            className="flat"
            onValidSubmit={handleSubmit}
        >
            <div className="col-xs-6 col-sm-2 col-md-3 padding-left-0">
                <Input
                    required
                    name="price"
                    id="browseByBudgetPriceInput"
                    type="tel"
                    validations={{
                        isValidPrice: true,
                    }}
                    validationError="Please enter a price."
                    placeholder={
                        budgetSummaryType === 'monthly'
                            ? 'Ex: $250'
                            : 'Ex: $25,000'
                    }
                    value={populatePriceInputValue()}
                    pattern="[0-9,$]{1,10}"
                    mask={priceMask}
                    onBlur={(e) => {
                        handleInputBlur(e);
                    }}
                />
            </div>
            <div className="col-xs-6 col-sm-3 col-md-5 padding-horizontal-0">
                <Select
                    required
                    aria-label="Select search criteria"
                    id="budget-module-toggle"
                    name="searchByBudgetCriteria"
                    style={{
                        textAlign: 'left',
                    }}
                    value={
                        budgetSummaryType === 'monthly' ? 'monthly' : 'purchase'
                    }
                    options={[
                        {
                            value: 'monthly',
                            label: 'per month',
                        },
                        {
                            value: 'purchase',
                            label: 'vehicle price',
                        },
                    ]}
                    onChange={(e) => {
                        setBudgetSummaryType(e.target.value);
                        dispatch(paymentsDuck?.creators?.updateMyWalletInteractions({
                            budgetSummaryType: e.target.value,
                        }));
                    }}
                />
            </div>
            <Text
                className="display-sm-none col-xs-12 padding-left-0 margin-bottom-2"
                data-cmp="BrowseByBudgetDirections"
            >
                Add your down payment and trade-in to see cars in your budget.
            </Text>
            <div
                className="display-flex align-items-center col-xs-12 col-sm-3 col-md-4 margin-bottom-2 padding-horizontal-0 padding-horizontal-sm-2"
                style={{ height: '48px' }}
            >
                <Button
                    block
                    bsStyle="primary-inverse"
                    type="submit"
                >
                    Continue
                </Button>
            </div>
            <Text className="display-none display-sm-block col-xs-12 col-sm-9 col-md-12 padding-left-0">
                Add your down payment and trade-in to see cars in your budget.
            </Text>
        </Form>
    );
}

export default BrowseByBudgetForm;
